export const OPEN_CLOSE_MODAL_SIDEBAR_OBJECT_STORE = 'open-close-modal-sidebar';
export const REFRESH_ACCESS_TOKEN_OBJECT_STORE = 'refresh-access-token';

export const REFRESH_TOKEN_INDEX_DB_KEY = 'refresh-access-token-timer';
